module.exports = __webpack_public_path__ + "static/2-score-analysis-24a0b33c201737606c90f4983990218c.png";